var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"width":800,"height":200,"speed":2,"viewBox":"0 0 800 200","primaryColor":_vm.primaryColor,"secondaryColor":"#D1D1D1"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"5","ry":"5","width":"800","height":"200"}})])}
var staticRenderFns = []

export { render, staticRenderFns }